module.exports = __webpack_public_path__ + "img/vision.09e0a4e4.png";